import React from 'react';
import styled from '@emotion/styled';
import Layout from '../components/layout/Layout';
import { theme } from '../styles/theme';

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: ${theme.spacing['2xl']} ${theme.spacing.xl};
`;

const Title = styled.h1`
  font-size: ${theme.typography.fontSize['3xl']};
  color: ${theme.colors.text.primary};
  margin-bottom: ${theme.spacing.xl};
`;

const Section = styled.section`
  margin-bottom: ${theme.spacing['2xl']};
`;

const SectionTitle = styled.h2`
  font-size: ${theme.typography.fontSize['xl']};
  color: ${theme.colors.text.primary};
  margin-bottom: ${theme.spacing.lg};
`;

const List = styled.ul`
  margin-bottom: ${theme.spacing.lg};
  padding-left: ${theme.spacing.xl};
  
  li {
    color: ${theme.colors.text.secondary};
    margin-bottom: ${theme.spacing.sm};
    line-height: 1.6;
  }
`;

const LastUpdated = styled.p`
  font-size: ${theme.typography.fontSize.sm};
  color: ${theme.colors.text.light};
  margin-top: ${theme.spacing['2xl']};
  text-align: center;
`;

const RefundPolicy = () => {
  return (
    <Layout>
      <Container>
        <Title>Subscription Cancellation & Refund Policy</Title>

        <Section>
          <SectionTitle>Billing Terms</SectionTitle>
          <List>
            <li>Monthly subscriptions are billed on a recurring 30-day basis, with charges processed 30 days from the original billing date.</li>
            <li>Annual subscriptions are billed on a recurring 12-month basis.</li>
          </List>
        </Section>

        <Section>
          <SectionTitle>Cancellation Policy</SectionTitle>
          <List>
            <li>Customers may cancel their subscription at any time by visiting the billing settings page.</li>
            <li>To ensure cancellation before the next billing cycle, notice must be received prior to the subscription renewal date.</li>
          </List>
        </Section>

        <Section>
          <SectionTitle>Refunds</SectionTitle>
          <List>
            <li>Refunds may be requested by email to <a href="mailto:cancellations@neatschedule.com">cancellations@neatschedule.com</a></li>
            <li>Users may only be eligible for a refund if the request is made within 48 hours of the renewal of their subscription.</li>
            <li>All refunds will be issued less any applicable processing, transaction, or service fees.</li>
            <li>Please allow a reasonable processing time for refunds to reflect on your account.</li>
          </List>
        </Section>

        <LastUpdated>
          Last Updated: {new Date().toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}
        </LastUpdated>
      </Container>
    </Layout>
  );
};

export default RefundPolicy; 